// extracted by mini-css-extract-plugin
module.exports = {"galleryContainer":"blockgallery-module--galleryContainer--XZhP4","h3Gallery":"blockgallery-module--h3Gallery--1LX3o","h4Gallery":"blockgallery-module--h4Gallery--1-VCz"};